<template>
	<div class="">
		<img class="logo" v-if="name.startsWith('http')" :src="name" />
		<h1 class="logo" v-else>{{ name }}</h1>
		<b-form @submit="onSubmit">
			<b-form-group
				id="user_group"
				:label="$t('connect.login') "
				label-for="user">
				<b-form-input
					id="user"
					type="text"
					v-model="form.user"
					required
					:placeholder="$t('connect.login')"></b-form-input>
			</b-form-group>
			<b-form-group
				id="pwd_group"
				:label="$t('connect.password')"
				label-for="pwd">
				<b-form-input
					id="pwd"
					type="password"
					v-model="form.pwd"
					required
					placeholder="$t('connect.password')"></b-form-input>
			</b-form-group>
			<b-form-group
				id="client_group"
				label="Client"
				label-for="client">
				<b-form-input
					id="client"
					type="text"
					v-model="form.client"
					placeholder="Client"></b-form-input>
			</b-form-group>
			<b-form-group
				id="client_group"
				label="Client user"
				label-for="user">
				<b-form-input
					id="user_client"
					type="text"
					v-model="form.user_client"
					placeholder="Client user"></b-form-input>
			</b-form-group>
			<b-button type="submit" variant="primary">{{ $t('ui.validate') }}</b-button>
		</b-form>
		<p style="margin-top: 10px">
			<a href="/password_reset">{{ $t("connect.forgotten_password")}}</a>
		</p>
		<div>
			<b-alert v-if="error" show>{{ errorMsg }}</b-alert>
		</div>


		<!-- <a :href='saas_back + "/users/login_google"'>
			<i class="fab fa-google fa-lg"/>
			Google
		</a> -->
	</div>
</template>

<script>
	import login from "../services/login.js";
	import users from "../services/users.js";

	export default {
		nam: "login_admin",
		data() {
			return {
				form: {
					user: "",
					pwd: "",
					client: "",
					user_client: ""
				},
				error: false,
				errorMsg: null,
				name: this.$t('smartmydata'),
				saas_back: process.env.VUE_APP_SAAS_BACK
			};
		},
		methods: {
			login_google()
			{
				login.login_google()
			},
			onSubmit(evt) {
				evt.preventDefault();
				login
					.auth(this.form.user, this.form.pwd, this.form.client, this.form.user_client)
					.then(async (res) => {
						let jwt = res.data.jwt;
						this.$store.commit("setJwt", jwt);

						var response = await users.getSelf(true);
						this.$store.commit("setUser", response.user);						

						this.$emit("loginSuccess");
						this.$router.push({ name: "main" });
					})
					.catch(() => {
						this.error = true;
						this.errorMsg = this.$t('connect.invalid_credentials');
					});
			},
		},
	};
</script>

<style>
	.baground {
		margin-right: 250px;
	}
	.logo {
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
